<template>
  <common-dialog ref="dialog" width="600px" title="核对修改地址" id-key="id" :data="data" @edit-opened="onEditOpened"
    :form-rules="rules" :save-func="saveDataFunc" reset-on-close @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="收件人" prop="receiverAddress.fullName">
        <el-input v-model="data.receiverAddress.fullName" placeholder="请输入收件人"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="receiverAddress.mobilePhone">
        <el-input v-model="data.receiverAddress.mobilePhone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="receiverAddress.detailAddress">
        <el-input v-model="data.receiverAddress.detailAddress" placeholder="请输入详细地址"></el-input>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';
import pddPrint from "@/components/common/pddPrint"

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    pddPrint
  },
  data() {
    return {
      api: require('@/api/pdd/malladdresses').default,
      logisticsApi: require('@/api/pdd/logistics').default,
      data: {
        id: 0,
        wpCode: "", //快递公司Code
        address: "",
        shopId: 0, //店铺id
        shopName: "大龙猫杂货店", //店铺名称
        receiverAddress: {
          country: "",
          province: "",
          city: "",
          district: "",
          street: "",
          detailAddress: "",
          postalCode: "",
          fullName: "",
          mobilePhone: "",
          dataMasking: false, //数据脱敏
        },
      },
      rules: {
        // wpCode: [{ required: true, message: '请选择快递公司' }],
        'receiverAddress.fullName': [{ required: true, message: '寄件人不能为空' }],
        'receiverAddress.mobilePhone': [{ required: true, message: '手机号码不能为空' }],
        // address: [{ required: true, message: '请选择发货地址' }],
        'receiverAddress.detailAddress': [{ required: true, message: '请选择发货地址' }],
      },
      companiesList: [],
      senderAddresses: [],
    };
  },
  mounted() { },
  methods: {
    onEditOpened() {

    },
    onAddressSelect(e) {
      // this.data.address = e.map(x => x.label).join("/");
      console.log("111", e);
      // console.log("222", this.data.address);
      // console.log("333", this.data.address);
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
        // this.api.postSender(this.data).then(res => {
        //   if (res) {
        //     resolve({ Code: 1, Msg: res.errorMessage })
        //   } else {
        //     resolve({ Code: 0, Msg: null })
        //   }
        // })
      })
    },
  },
};
</script>
